// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    GIFT_LOADING() {
      return {
        isLoading: true
      };
    },
    GIFT_LOADED() {
      return {
        isLoading: false,
        data: action.gift
      };
    },
    GIFT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.gift.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
